import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import { Get } from "../../lib/Config";
import { data } from "jquery";
import ScrollOut from "scroll-out";

const Ceo = () => {
    const [content, setContent] = useState("false");
    useEffect(() => {
        Get("CEO", res => {
            setContent(res.value);
        });
        ScrollOut({
            threshold: 0.3,
            once: true
        });
    }, []);

    return (
        <>
            <SubHead title="CEO 인사말" eng="GREET"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <p class="tit-guide-sbj" data-scroll>
                        kt MOS 북부는 앞선 기술과 품질로 <br />
                        고객의 보다 나은 미래를 만드는 <br />
                        <b>AI 혁신 파트너</b>가 되겠습니다.
                    </p>

                    <div className="ceo-greet-wrap gray-back-bg">
                        <h2 data-scroll>kt MOS 북부 홈페이지를 찾아주신 고객 여러분 감사합니다.</h2>
                        <h3 style={{ whiteSpace: "pre-line" }} data-scroll>
                            {/* kt MOS 북부는 KT의 그룹사로서 무선 Network를 최상의 상태로 유지∙관리하여 고객에게 최고의 품질을 서비스하고 있는 Network 운용 전문회사입니다. <br />
                            KT의 핵심 미래사업에 중요한 파트너로서 4차 산업혁명시대를 맞이하여 5G, IoT 등 역량을 결집하여 최고의 기술력을 <br />
                            갖춘 “Global No.1 Network Service Company”로 거듭나고 있습니다.
                            <br />
                            <br />
                            또한, 전 임직원은 직원이 행복하고 소통이 잘되는 회사, 즉, “즐겁고 신나는 일터”를 만들어 나아가고 있습니다.
                            <br />
                            <br />
                            kt MOS 북부에 변함없는 관심과 성원을 부탁드립니다. <br />
                            <br />
                            감사합니다. */}
                            {content}
                        </h3>
                        <div className="name_box" data-scroll>
                            {/* <span className="logo"></span> */}
                            <span className="cate">kt MOS북부 대표이사</span>
                            <span className="name">김 철 기</span>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Ceo;
